import { ActiveFilterData, CategoryFacet } from '@nykaa/listing-shared/type/filter';


export const updateSelectedCount = (parentId: string, depth: number, increaseCount: boolean, filterTree: CategoryFacet[]) => {
  if (parentId && filterTree?.[`${depth}`]) {
    const tempCategoryObject = filterTree[`${depth}`].find(x => x.id === parentId);
    if (tempCategoryObject) {
      tempCategoryObject.selectedCount = tempCategoryObject.selectedCount || 0;
      const { selectedCount } = tempCategoryObject;
      if (increaseCount) {
        tempCategoryObject.selectedCount = selectedCount + 1;
      } else {
        tempCategoryObject.selectedCount = selectedCount - 1;
      }
      if (depth - 1 >= 0) {
        updateSelectedCount(tempCategoryObject.parent_id, depth - 1, increaseCount, filterTree);
      }
    }
  }
};

export const listToTreeWithCount = (list: CategoryFacet[], activeFilters: ActiveFilterData[]) => {
  const treeMap: any = {};
  try {
    const tempList = JSON.parse(JSON.stringify(list));
    tempList.forEach((item: any) => {
      if (!treeMap[item.depth]) {
        treeMap[item.depth] = [];
      }
      treeMap[item.depth].push(item);
      tempList.forEach((tempElement: any) => {
        if (tempElement.id === item.parent_id) {
          if (!tempElement.children) {
            tempElement.children = [];
          }
        }
      });
    });
    // for count
    activeFilters.map(filter => {
      const parentId = filter?.parentId || filter?.parent_id;
      const depth = Number(filter?.depth) || 0;
      updateSelectedCount(parentId, depth - 1, true, treeMap);
    });
    return treeMap;
  } catch (error) {
    // log exception
    return false;
  }
};


export const navigateUpFilters = (filterValue: CategoryFacet, filterTree: CategoryFacet[], activeTree: CategoryFacet[]) => {
  const currentDepth = parseInt(filterValue?.depth, 10);
  filterValue.children = [];
  if (currentDepth === 0) {
    return filterTree[0];
  }
  let tempTree = filterTree;
  const depth = Number(currentDepth - 1);
  tempTree = filterTree?.[`${depth}`];
  const parentObject = tempTree?.find(
    (tempElement: any) => tempElement?.id === filterValue?.parent_id
  );
  if (!parentObject) {
    return activeTree;
  }
  let parentDepth = parseInt(parentObject.depth, 10);
  parentDepth += 1;
  const children = filterTree?.[`${parentDepth}`]?.filter(
    (depthElement: any) => depthElement.parent_id === parentObject.id
  );
  parentObject.children = children;
  return [parentObject];
};

export const navigateDownFilters = (filterValue: CategoryFacet, filterTree: CategoryFacet[], activeTree: CategoryFacet[]) => {
  const currentDepth = parseInt(filterValue?.depth, 10);
  const depth = currentDepth + 1;
  const children = filterTree?.[`${depth}`]?.filter(
    (depthElement: any) => depthElement?.parent_id === filterValue?.id
  );
  filterValue.children = children;
  if (currentDepth === 0) {
    return [filterValue];
  }
  activeTree[0].children = [filterValue];
  return activeTree;
};
